import web from '@/core/middlewares/web'
import auth from "@/core/middlewares/auth";

let account = () => import(/* webpackChunkName: "account" */ '@/views/account/Account');
let changePassword = () => import(/* webpackChunkName: "account" */ '@/views/account/ChangePassword');
let security = () => import(/* webpackChunkName: "account" */ '@/views/account/Security');
let loginLogs = () => import(/* webpackChunkName: "account" */ '@/views/account/LoginLogs');
let legal = () => import(/* webpackChunkName: "account" */ '@/views/account/Legal');
let bank = () => import(/* webpackChunkName: "account" */ '@/views/account/BankAccount');

export default [
    {
        path: "/account/login-logs",
        name: "account.login_logs",
        component: loginLogs,
        meta: {
            middleware: web,
            title: "تاریخچه ورود"
        },
    },
    {
        path: "/account",
        component: () => import("@/views/account/Layout"),
        children: [
            {
                path: "",
                name: "account.index",
                components: {
                    account: account
                },
                meta: {
                    middleware: [auth],
                    title: "حساب کاربری من"
                },
            },
            {
                path: "change-password",
                name: "account.change_password",
                components: {
                    account: changePassword
                },
                meta: {
                    middleware: web,
                    title: "تغییر گذرواژه"
                },
            },
            {
                path: "security",
                name: "account.security",
                components: {
                    account: security
                },
                meta: {
                    middleware: web,
                    title: "تنظیمات امنیتی"
                },
            },
            {
                path: "company",
                name: "account.company",
                components: {
                    account: legal
                },
                meta: {
                    middleware: web,
                    title: "اطلاعات حقوقی"
                },
            },
            {
                path: "bank-account",
                name: "account.bank",
                components: {
                    account: bank
                },
                meta: {
                    middleware: web,
                    title: "اطلاعات بانکی"
                },
            }
        ]
    },
]